let initCalled;
let callbackPromise = new Promise(r => (window.__initMap = r));
export let loadAPI = API_KEY => {
  if (!initCalled) {
    const script = document.createElement('script');

    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=geometry,places&callback=__initMap`;
    document.head.appendChild(script);
    initCalled = true;
  }
  return callbackPromise;
};
